var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.542 17.417V6.167h2.5V4.542c0-1.14.382-2.09 1.145-2.854C4.951.924 5.889.542 7 .542c1.111 0 2.049.382 2.812 1.146.764.763 1.146 1.715 1.146 2.854v1.625h2.5v11.25H.542ZM4.5 6.167h5V4.542c0-.695-.243-1.292-.729-1.792A2.377 2.377 0 0 0 7 2c-.695 0-1.285.25-1.771.75A2.481 2.481 0 0 0 4.5 4.542v1.625ZM2 15.958h10V7.625H2v8.333Zm5-2.562c.445 0 .816-.15 1.115-.448.298-.299.447-.67.447-1.115 0-.444-.149-.815-.447-1.114A1.513 1.513 0 0 0 7 10.271c-.445 0-.816.15-1.115.448-.298.299-.447.67-.447 1.114 0 .445.149.816.447 1.115.299.299.67.448 1.115.448Z",
    fill: "#000"
  })));
};
export default SvgLock;